export const checkIsClosedCalendar = (masterBook) => {
  // masterBookのclosed_daysの中身があるかどうかを判定する。
  // closed_daysがない場合は空配列
  return masterBook.closed_days.length > 0;
};
